import React, { Component } from "react";
import moment from "moment";
import { ChatFeed, Message, ChatBubble } from "react-chat-ui";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  setReplyCustomerInfo,
  unsubscribeCustomer,
  getNotifications,
  subscribeCustomer,
  sendNotification,
  getReplies,
  markAsRead,
} from "../../../actions/notificationManager";

const $ = window.$;
let formData = {};
const initialState = {
  messages: [],
  message: "",
  customer: null,
  notificationStatus: null,
  isLoading: false,
  isMessageSending: false,
  isFormNotValid: false,
};

class CustomChatBubble extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ChatBubble
        message={this.props.message}
        bubbleStyles={{
          text: {
            fontSize: 13,
            color: this.props.message.id === 0 ? "#fff" : "#000",
          },
          chatbubble: {
            borderRadius: 10,
          },
        }}
      />
    );
  }
}

class ViewReplies extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.replies !== nextProps.replies) {
      if (nextProps.replies.length > 0) {
        let messages = [];
        let message;

        for (let reply of nextProps.replies) {
          message = new Message({
            id: reply.group,
            message: reply.message,
          });
          messages.push(message);
        }

        this.setState({ messages: messages });
      }
    }

    if (this.props.customerInfo !== nextProps.customerInfo) {
      if (nextProps.customerInfo && nextProps.customerInfo.customer) {
        this.setState({
          customer: nextProps.customerInfo.customer,
          notificationStatus: nextProps.customerInfo.notificationStatus,
        });
      }
    }

    // Unsubscribe customer
    if (this.props.unsubscribedCustomer !== nextProps.unsubscribedCustomer) {
      if (nextProps.unsubscribedCustomer && nextProps.unsubscribedCustomer.message) {
        NotificationManager.success(nextProps.unsubscribedCustomer.message);
        this.props.getNotifications();
        this.setState({
          isLoading: false,
          notificationStatus: nextProps.unsubscribedCustomer.information.status,
        });

        window.location.reload();
      }
    }

    if (this.props.unsubscribedCustomerError !== nextProps.unsubscribedCustomerError) {
      this.setState({ isLoading: false });
      if (nextProps.unsubscribedCustomerError && nextProps.unsubscribedCustomerError.details) {
        NotificationManager.error(nextProps.unsubscribedCustomerError.details.message);
      }
    }

    // Subscribe customer
    if (this.props.subscribedCustomer !== nextProps.subscribedCustomer) {
      if (nextProps.subscribedCustomer && nextProps.subscribedCustomer.message) {
        NotificationManager.success(nextProps.subscribedCustomer.message);
        this.props.getNotifications();
        this.setState({
          isLoading: false,
          notificationStatus: nextProps.subscribedCustomer.information.status,
        });

        window.location.reload();
      }
    }

    if (this.props.subscribeCustomerError !== nextProps.subscribeCustomerError) {
      this.setState({ isLoading: false });
      if (nextProps.subscribeCustomerError && nextProps.subscribeCustomerError.details) {
        NotificationManager.error(nextProps.subscribeCustomerError.details.message);
      }
    }

    if (this.props.sendIndividualMessage !== nextProps.sendIndividualMessage) {
      this.props.getReplies(this.state.customer.id);
      this.setState({ isMessageSending: false, message: "" });
    }

    if (this.props.sendIndividualMessageError != nextProps.sendIndividualMessageError) {
      if (nextProps.sendIndividualMessageError && nextProps.sendIndividualMessageError.details) {
        this.setState({ isMessageSending: false });
        NotificationManager.error(nextProps.sendIndividualMessageError.details.message);
      }
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateForm = () => {
    const { message } = this.state;

    const data = {
      message: message && message.trim().length > 0 ? message : null,
      message_length: message && message.length <= 160 ? message : null,
    };

    formData = Object.assign({}, data);
    return true;
  };

  sendMessage = (e) => {
    e.preventDefault();
    const isFormValid = this.validateForm();

    if (isFormValid) {
      let data = Object.values(formData).map((key) => {
        return key !== null;
      });

      if (!data.includes(false)) {
        const { message, customer } = this.state;
        this.props.sendNotification(customer.id, message);
        this.setState({ isMessageSending: true });
      } else {
        this.setState({ isFormNotValid: true });
        NotificationManager.warning("Please check the input details again");
      }
    }
  };

  refreshThread = (e) => {
    e.preventDefault();
    this.props.getReplies(this.state.customer.id);
    this.props.markAsRead(this.state.customer.id);
    NotificationManager.success("Message thread refreshed");
  };

  closeModal = () => {
    this.setState(initialState);
    this.props.setReplyCustomerInfo(null);
    $("#view-replies").modal("toggle");
  };

  unsubscribeCustomer = (e) => {
    if (this.state.customer && this.state.customer.id) {
      this.props.unsubscribeCustomer(this.state.customer.id);
      this.setState({ isLoading: true });
    }
  };

  subscribeCustomer = (e) => {
    if (this.state.customer && this.state.customer.id) {
      this.props.subscribeCustomer(this.state.customer.id);
      this.setState({ isLoading: true });
    }
  };

  render() {
    const { messages, customer, isLoading, notificationStatus, isMessageSending, isFormNotValid, message } = this.state;
    $("#message-thread").animate({ scrollTop: $("#message-thread").prop("scrollHeight") }, 1000);

    return (
      <div className="modal fade mt-3" id="view-replies" tabIndex="-1" role="dialog" data-backdrop="static">
        <div className="modal-dialog modal-reply-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {customer && customer.firstname} {customer && customer.lastname}'s Replies{" "}
                <i
                  className="fas fa-sync refresh-thread-icon"
                  title="Refresh message thread"
                  onClick={this.refreshThread}
                ></i>
              </h5>
              <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body reply-body">
              {messages.length > 0 ? (
                <div className="message-thread-outer-div scroll-bar" id="message-thread">
                  <div className="message-thread-inner-div">
                    <ChatFeed messages={messages} chatBubble={CustomChatBubble} />
                  </div>
                </div>
              ) : (
                <span className="m-badge m-badge--secondary mx-auto my-0 px-2 no-reply-message">
                  {customer && `Currently there are no replies from ${customer.firstname} ${customer.lastname}`}
                </span>
              )}

              <div className="d-flex justify-content-center">
                <div className="input-group send-message-field">
                  <input
                    type="text"
                    className="form-control"
                    name="message"
                    value={message}
                    onChange={this.onChange}
                    placeholder="Message"
                    aria-label="Message"
                  />
                  <button
                    className="btn btn-outline-primary"
                    type="button"
                    id="button-addon2"
                    title="Send"
                    data-mdb-ripple-color="dark"
                    onClick={this.sendMessage}
                    disabled={isMessageSending}
                  >
                    {isMessageSending ? <Loader size={18} /> : <i className="fa fa-paper-plane"></i>}
                  </button>
                </div>
              </div>
              <div className="d-flex">
                <div className="send-message-warning">
                  {isFormNotValid && formData.message === null ? (
                    <span className="validate-warning">Message is required</span>
                  ) : null}
                  {isFormNotValid && formData.message !== null && formData.message_length === null ? (
                    <span className="validate-warning">Maximum character count exceed</span>
                  ) : null}
                </div>
                <div className="send-message-length">{message.trim().length}/160</div>
              </div>
            </div>
            <div className="modal-footer">
              {isLoading ? (
                <Loader size={50} />
              ) : (
                <div>
                  <button className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>
                    Close
                  </button>
                  {notificationStatus && notificationStatus === "Unsubscribed" ? (
                    <button
                      className="btn btn-primary m-btn--pill mx-2"
                      defaultChecked
                      onClick={this.subscribeCustomer}
                    >
                      Subscribe
                    </button>
                  ) : null}

                  {notificationStatus && notificationStatus !== "Unsubscribed" ? (
                    <button
                      className="btn btn-primary m-btn--pill mx-2"
                      defaultChecked
                      onClick={this.unsubscribeCustomer}
                    >
                      Unsubscribe
                    </button>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  replies: state.notificationManagerReducer.replies,
  customerInfo: state.notificationManagerReducer.replyCustomer,
  unsubscribedCustomer: state.notificationManagerReducer.unsubscribeCustomer,
  unsubscribedCustomerError: state.notificationManagerReducer.unsubscribeCustomerError,
  subscribedCustomer: state.notificationManagerReducer.subscribeCustomer,
  subscribeCustomerError: state.notificationManagerReducer.subscribeCustomerError,
  sendIndividualMessage: state.notificationManagerReducer.sendIndividualNotification,
  sendIndividualMessageError: state.notificationManagerReducer.sendIndividualNotificationError,
});

const mapDispatchToProps = (dispatch) => ({
  setReplyCustomerInfo: (data) => {
    dispatch(setReplyCustomerInfo(data));
  },
  unsubscribeCustomer: (id) => {
    dispatch(unsubscribeCustomer(id));
  },
  subscribeCustomer: (id) => {
    dispatch(subscribeCustomer(id));
  },
  getNotifications: () => {
    dispatch(getNotifications());
  },
  sendNotification: (customerId, message) => {
    dispatch(sendNotification(customerId, message));
  },
  getReplies: (id) => {
    dispatch(getReplies(id));
  },
  markAsRead: (customerId) => {
    dispatch(markAsRead(customerId));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewReplies));
